import Initial from '../../../components/Initial'
import Panel, { PanelBody } from '../../../components/Panel'
import useInitial from '../useInitial'
import FilterProviders from './FilterProviders'
import Table from './Table'

export default function Providers() {
    const state = useInitial()

    return (
        <Initial pageState={state}>
            <Panel>
                <PanelBody>
                    <FilterProviders />
                    <Table />
                </PanelBody>
            </Panel>
        </Initial>
    )
}
